import { z } from 'zod';

export const roleRepResDto = z.object({
  id: z.string().uuid(),
  name: z.string(),
});
